<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <div :class="b()">
    <h1 :class="b('title')">
      {{ $t("История операций") }}
    </h1>

    <div :class="b('wrapper')">
      <!-- <AdminUsersFilter
        v-model:value="search.value"
        v-model:type="search.type"
      /> -->

      <AdminWalletHistoryTable
        :class="b('table')"
        :search="search"
        :sort="sort"
        :history="history"
      />

      <SharedButtonIcon
        v-if="isMoreShow"
        :class="b('more')"
        view="gray-outline"
        @click="handleMore"
      >
        <template #icon-left>
          <span :class="b('more-icon')" v-html="displayedIcons.more"></span>
        </template>

        <template #label>
          {{ $t("Показать больше") }}
        </template>
      </SharedButtonIcon>
    </div>
  </div>
</template>
